import { render, staticRenderFns } from "./CargoSinFelComponent.vue?vue&type=template&id=6838941e&"
import script from "./CargoSinFelComponent.vue?vue&type=script&lang=js&"
export * from "./CargoSinFelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports